/* eslint-disable arrow-body-style */
import { handleActions } from 'redux-actions';

import { TYPE } from './actions';

const reducer = handleActions(
    {
        [TYPE.FETCH_USERS_LOADING]: (state) => {
            return {
                ...state,
                loading: true
            };
        },
        [TYPE.FETCH_USERS_SUCCESS]: (state, action) => {
            return {
                ...state,
                data: action.payload,
                loading: false
            };
        },
        [TYPE.FETCH_USERS_ERROR]: (state, action) => {
            return {
                ...state,
                data: [],
                loading: false,
                error: action.payload
            };
        },

        [TYPE.EDIT]: (state, action) => {
            return {
                ...state,
                modals: {
                    editUser: {
                        active: true,
                        data: action.payload
                    }
                }
            };
        },

        [TYPE.TOGGLE_EDIT_MODAL]: (state, action) => {
            const { payload } = action;

            return {
                ...state,
                modals: {
                    editUser: {
                        active: payload.active,
                        data: payload.data
                    }
                }
            };
        },
        [TYPE.PREPARE_FILTER_SUCCESS]: (state, action) => {
            return {
                ...state,
                filterValues: action.payload
            };
        },
    },
    {
        loading: false,
        data: [],
        filterValues: [],
        error: null,
        pagination: {
            size: 25,
            page: 0
        },
        modals: {
            editUser: {
                active: false,
                data: {},
            },
        },
    }
);

export default reducer;
